import { features } from "@/mocks/siteData";

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="text-xs font-semibold uppercase tracking-widest text-foreground-400">Why Choose Us</span>
          <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-foreground-950 mt-3 leading-[1.15]">
            Everything You Need
            <br />
            In One Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}